import { Themes } from "../../types/types";

export const defaultDarkTheme: Themes = "blackout";
export const defaultLightTheme: Themes = "github-light-default";
